import React, { Component } from "react";
import { FaGraduationCap } from "react-icons/fa";
import Title from "../GenericComponents/Title";
import Paginations from "../GenericComponents/Pagination";
import { search_ApiManager, post_ApiManager } from "../ApiManager/ApiManager";
import Modals from "../GenericComponents/Modal";
import CounclingSelectionBar from "./CounclingSelectionBar";
import CounselingCourseCard, {
  CounselingCourseCardSkeleton,
} from "./CounselingCourseCard";
import "../../styles/tailwind.css";

class Counseling extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      facetLoading: false,
      baselineFacetLoaded: false,
      apiFilterOptions: null,
      providerList: [],
      courseList: [],
      counseling: [],
      totalItem: 0,
      currentPage: 1,
      perItem: 0,
      lastPage: "",
      perPage: 12,
      selectedCountry: "",
      selectedLevel: "",
      selectedDiscipline: "",
      selectedTutionFee: "",
      selectedIntake: "",
      selectedDuration: "",
      selectedCourse: [],
      selectedProvider: [],
      selectedPrerequisit: "",
      selectedCampus: "",
      selectedIntakeId: "",
      show: false,
    };
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    this.fetchFilterOptions(() => this.getCounseling());
  }

  buildFilterOptionsPayload = () => {
    const selectedProviders = Array.isArray(this.state.selectedProvider)
      ? this.state.selectedProvider
      : [];
    const selectedCourses = Array.isArray(this.state.selectedCourse)
      ? this.state.selectedCourse
      : [];
    return {
      country: this.state.selectedCountry,
      discipline: this.state.selectedDiscipline,
      fee: this.state.selectedTutionFee,
      level: this.state.selectedLevel,
      intake: this.state.selectedIntakeId,
      duration: this.state.selectedDuration,
      campus: this.state.selectedCampus,
      prerequisite: this.state.selectedPrerequisit,
      provider: selectedProviders.map((item) => ({
        id: item.id ?? item.value,
        name: item.name ?? item.label,
      })),
      course: selectedCourses
        .map((item) => item.id ?? item.value)
        .filter((item) => item !== "" && item != null),
    };
  };

  fetchFilterOptions = (callback) => {
    this.setState({ facetLoading: true });
    post_ApiManager(
      this.buildFilterOptionsPayload(),
      "counseling/filter-options",
      (res) => {
        const filters = res.data?.filters || {};
        const providers = Array.isArray(filters.providers) ? filters.providers : [];
        this.setState(
          {
            apiFilterOptions: filters,
            providerList: providers,
            facetLoading: false,
            baselineFacetLoaded: true,
          },
          () => {
            if (typeof callback === "function") callback();
          },
        );
      },
      () => {
        this.setState({ facetLoading: false, baselineFacetLoaded: true }, () => {
          if (typeof callback === "function") callback();
        });
      },
    );
  };

  handleCallback = (toggle, type, value1, value2) => {
    if (type === "edit") {
      localStorage.setItem("student_country", JSON.stringify(value1));
      localStorage.setItem("residence_country", JSON.stringify(value2));
    }
    this.setState({ show: !toggle });
  };

  buildSearchPayload = () => {
    const selectedProviders = Array.isArray(this.state.selectedProvider)
      ? this.state.selectedProvider
      : [];
    const selectedCourses = Array.isArray(this.state.selectedCourse)
      ? this.state.selectedCourse
      : [];
    return {
      country: this.state.selectedCountry,
      discipline: this.state.selectedDiscipline,
      fee: this.state.selectedTutionFee,
      level: this.state.selectedLevel,
      intake: this.state.selectedIntakeId,
      duration: this.state.selectedDuration,
      campus: this.state.selectedCampus,
      prerequisite: this.state.selectedPrerequisit,
      provider: selectedProviders.map((item) => ({
        id: item.id ?? item.value,
        name: item.name ?? item.label,
      })),
      course: selectedCourses
        .map((item) => item.id ?? item.value)
        .filter((item) => item !== "" && item != null),
    };
  };

  triggerSearch = () => {
    this.setState({ loading: true, currentPage: 1 }, () => {
      this.fetchFilterOptions(() => this.getCounseling());
    });
  };

  handleBarCallback = (value, name, optionName) => {
    if (name === "countries") {
      this.setState(
        {
          selectedCountry: value,
          selectedProvider: [],
          selectedCourse: [],
        },
        this.triggerSearch,
      );
      return;
    }

    if (name === "levels") {
      this.setState({ selectedLevel: value }, this.triggerSearch);
    } else if (name === "course") {
      this.setState({ selectedCourse: value || [] }, this.triggerSearch);
    } else if (name === "discipline") {
      this.setState({ selectedDiscipline: value }, this.triggerSearch);
    } else if (name === "tutionfee") {
      this.setState({ selectedTutionFee: value }, this.triggerSearch);
    } else if (name === "intake") {
      this.setState(
        { selectedIntake: optionName, selectedIntakeId: value },
        this.triggerSearch,
      );
    } else if (name === "duration") {
      this.setState({ selectedDuration: value }, this.triggerSearch);
    } else if (name === "prerequisit") {
      this.setState({ selectedPrerequisit: value }, this.triggerSearch);
    } else if (name === "campus") {
      this.setState({ selectedCampus: value }, this.triggerSearch);
    } else if (name === "provider") {
      this.setState(
        {
          selectedProvider: value || [],
          selectedCourse: [],
        },
        this.triggerSearch,
      );
    }
  };

  getCounseling() {
    const { currentPage, perPage } = this.state;
    const data = this.buildSearchPayload();

    search_ApiManager(
      "counseling",
      data,
      currentPage,
      perPage,
      (res) => {
        const paginator = res.data?.data || {};
        const rows = Array.isArray(paginator.data)
          ? paginator.data
          : Array.isArray(res.data?.courses)
            ? res.data.courses
            : [];

        this.setState({
          counseling: rows,
          loading: false,
          totalItem: paginator.total ?? rows.length,
          perPage: paginator.per_page ?? perPage,
          lastPage: paginator.last_page ?? 1,
          perItem: rows.length,
          courseList: rows,
        });
      },
      () => {
        this.setState({ loading: false, counseling: [], courseList: [], totalItem: 0 });
      },
    );
  }

  onSubmit(e) {
    e.preventDefault();
    this.triggerSearch();
  }

  onClear = () => {
    this.setState(
      {
        selectedLevel: "",
        selectedCountry: "",
        selectedDiscipline: "",
        selectedDuration: "",
        selectedIntake: "",
        selectedIntakeId: "",
        selectedPrerequisit: "",
        selectedTutionFee: "",
        selectedCourse: [],
        selectedCampus: "",
        selectedProvider: [],
        currentPage: 1,
        loading: true,
      },
      () => {
        this.fetchFilterOptions(() => this.getCounseling());
      },
    );
  };

  handlePaginationCallback = (i, perPage) => {
    if (perPage && perPage != "") {
      this.setState({ perPage: perPage, currentPage: 1, loading: true }, () =>
        this.getCounseling(),
      );
    } else {
      this.setState({ currentPage: i, loading: true }, () => this.getCounseling());
    }
  };

  render() {
    const displayedCourses = this.state.counseling || [];
    const resultCount = this.state.totalItem;

    const showPagination =
      displayedCourses.length > 0 && this.state.totalItem > this.state.perPage;

    return (
      <>
        <Title title="Counseling" flushLeft />
        <div className="tailwind-container min-h-[calc(100vh-120px)] rounded-xl bg-gradient-to-b from-slate-50 to-slate-100">
          <div className="px-2 pb-8 sm:px-3">
            <CounclingSelectionBar
              defaultCountry={this.state.selectedCountry}
              defaultCourse={this.state.selectedCourse}
              providerList={this.state.providerList}
              apiFilterOptions={this.state.apiFilterOptions}
              facetLoading={this.state.facetLoading && !this.state.baselineFacetLoaded}
              defaultProvider={this.state.selectedProvider}
              defaultDiscipline={this.state.selectedDiscipline}
              defaultFee={this.state.selectedTutionFee}
              defaultIntake={this.state.selectedIntake}
              defaultIntakeId={this.state.selectedIntakeId}
              defaultLevel={this.state.selectedLevel}
              defaultDuration={this.state.selectedDuration}
              defaultPrerequisit={this.state.selectedPrerequisit}
              defaultCampus={this.state.selectedCampus}
              parentCallback={this.handleBarCallback}
              handleReset={this.onClear}
              resultCount={resultCount}
              resultsLoading={this.state.loading}
            />

            <section className="counseling-pathways-section">
              {this.state.loading ? (
                <div className="counseling-courses-grid">
                  {Array.from({ length: 12 }).map((_, item) => (
                    <CounselingCourseCardSkeleton key={`counseling-skeleton-${item}`} />
                  ))}
                </div>
              ) : !(displayedCourses && displayedCourses[0]) ? (
                <div className="rounded-2xl border border-dashed border-slate-300 bg-white px-6 py-12 text-center">
                  <div className="mb-3 inline-flex h-14 w-14 items-center justify-center rounded-full bg-blue-50 text-blue-500">
                    <FaGraduationCap size={28} />
                  </div>
                  <p className="m-0 text-sm font-semibold text-slate-600">
                    No pathways match this client profile
                  </p>
                  <p className="mx-auto mt-1.5 max-w-[360px] text-xs text-slate-400">
                    Adjust budget, degree level, or English test — or pick a recommended destination above
                  </p>
                </div>
              ) : (
                <div className="counseling-courses-grid">
                  {displayedCourses.map((course) => (
                    <CounselingCourseCard
                      key={`${course.id}-${course.providerid}`}
                      course={course}
                    />
                  ))}
                </div>
              )}

              {showPagination ? (
                <div className="mt-4">
                  <Paginations
                    currentPage={this.state.currentPage}
                    total={this.state.totalItem}
                    itemsPerPage={this.state.perPage}
                    lastPage={this.state.lastPage}
                    totalItems={this.state.totalItem}
                    perItem={this.state.perItem}
                    perPageOptions={[12, 24, 36, 48]}
                    onPageChange={this.handlePaginationCallback}
                  />
                </div>
              ) : null}
            </section>
          </div>
        </div>
        <Modals
          show={this.state.show}
          title={"Select your student details"}
          type={"counseling"}
          submitBtnText={"Proceed"}
          parentCallback={this.handleCallback}
        />
      </>
    );
  }
}

export default Counseling;
